import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { redirectUrlAction } from '../../middleware/redirectUrlAction';
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import ProductRestrictModalMiniCart from '../ShoppingList/ProductRestrictModalMiniCart';
function MyCartTile(props) {
    var profile = props.profile;
    const MyCartDetails = props.data?.[0]?.ContentRuleZone?.[0]?.attributes
    const  mainImage = props.data?.[0]?.ContentRuleZone?.[0]?.menuImage
    const  altText = props.data?.[0]?.ContentRuleZone?.[0]?.attributes?.altText

    var miniCartItemsCount = props?.miniCartItemsCount;
    var miniCartItems = props.miniCartItems;
    const [checkoutHref, setCheckoutHref] = useState('/checkout/login');
    const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef("")
    const [checkoutQuarantine, setCheckoutQuarantine, checkoutQuarantineRef] = useStateRef(null);
    const [restrictedItem, setRestrictedItem] = useState();
    const [restrictedItemGeo, setRestrictedItemGeo] = useState();
    const [restrictedItemSpecialUser, setRestrictedItemSpecialUser] = useState();
    const [restrictedDiscontinueItem, setRestrictedDiscontinueItem] = useState();
    const [restrictedTitle, setRestrictedTitle] = useState();
    const [isRestrictedModalShow, setIsRestrictedModalShow, isRestrictedModalShowRef] = useStateRef(false);
    const [hideModal, setHideModal, hideModalRef] = useStateRef(false); 
    const [hasScrollView, setHasScrollView] = useState(false);
    const [userType, setUserType, userTypeRef] = useStateRef()
    const [emptyCart, setEmptyCart] = useState();
    const dispatch = useDispatch();
    const history = useHistory()
    const profileDetail = useSelector(state => state.getProfileDetails.profileDetails)
    useEffect(()=>{
        console.log('miniCartItemsCount....',miniCartItemsCount? miniCartItemsCount : '?');
    },[miniCartItemsCount])
    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;
    }
    const[renderType, setRenderType] = useState("");

    useEffect(() => {
        const profileDetailRestricted = () => {
            if (profileDetail) {
                if (!profileDetail?.hasOwnProperty('transient')) {
                    // console.log("User is logged in.");
                    if (userTypeRef.current && userTypeRef.current === 3) {
                        // console.log("User type is 3");
                        setCheckoutHref('/checkout/int/save')
                    } else {
                        // console.log("User type is not equal to 3");
                        setCheckoutHref('/checkout/shipping')
                    }
                } else {
                    console.log("User is anonymous.");
                    // dispatch(redirectUrlAction("/checkout/login"))
                    // setCheckoutHref('/checkout/login')
                }
            }
        }
        profileDetailRestricted()

    }, [profileDetail])

    useEffect(() => {
        setScreenWidth(screen.width);
      }, []);
useEffect(()=>{
    console.log('miniCartItems... in mycartTile',miniCartItems);
    console.log('pricingMode... in mycartTile',miniCartItems?.pricingMode);
    console.log('promotionCode... in mycartTile',miniCartItems?.promotionCode);

},[miniCartItems])

    useEffect(() => {
        if (profileDetail && profileDetail.transient) {
            setUserType(profileDetail)
        }
        if (profileDetail && !profileDetail.transient && profileDetail.userType) {
            setUserType(profileDetail.userType)
        }
        if(MyCartDetails.renderPosition) {
            setRenderType(MyCartDetails.renderPosition)
          }
    }, [profileDetail])

    async function handleGetCartList() {
        const cartParem = window.location.search
        var actionUrl = `api/rest/cb/cart/cart-details/${cartParem === '?create=true' ? 'true' : 'false'}`;
        fetch(`${window.location.protocol}//${window.location.hostname}/${actionUrl}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                console.log('res.isEmptyCart',res?.isEmptyCart)
                if (res.result === "success") {
                    console.log('res.isEmptyCart---',res?.isEmptyCart)
                }
                else {
                }
            })
    }

    async function handleCheckOut() {
        if (profileDetail?.hasOwnProperty('transient')) {
            dispatch(redirectUrlAction("/checkout/login"))
            setCheckoutHref('/checkout/login');
        }
       if (userTypeRef.current && userTypeRef.current !== 3) {
        await goToCheckout();
        var actionUrl = "api/rest/cb/cart/quarantine";
        var urlParam = `urlParam=${checkoutHref}&checkoutType=miniCart`
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            urlParam: urlParam
        }))
        if (res.result == "success") {
            var response = (JSON.parse(res.response)).response
            var restrictTitle = response?.restrictionProductsList ? response.restrictionProductsList : ''
            var restrictDiscontinueItem = response?.restrictionProductsList?.discontinuedProducts?.productDetailsList ?
            response.restrictionProductsList.discontinuedProducts.productDetailsList : ''
            var specificUsersRestrictionMap = response?.restrictionProductsList?.specificUsersRestriction?.productDetailsList ?
                response.restrictionProductsList.specificUsersRestriction.productDetailsList : ''
            var restrictSchoolMap = response?.restrictionProductsList?.schoolrestriction?.productDetailsList ?
                response.restrictionProductsList.schoolrestriction.productDetailsList : ''
            var restrictGeoMap = response?.restrictionProductsList?.geoRestriction?.productDetailsList ?
                response.restrictionProductsList.geoRestriction.productDetailsList : ''
            setRestrictedTitle(restrictTitle)
            setRestrictedDiscontinueItem(restrictDiscontinueItem)
            setRestrictedItem(restrictSchoolMap)
            setRestrictedItemGeo(restrictGeoMap)
            setRestrictedItemSpecialUser(specificUsersRestrictionMap)
            var restricteditem = response && response.quarantine
            var isCartEmptyCart = response && response.isCartEmptyCart
            console.log('modalShow.../',isRestrictedModalShowRef.current);
            if (restricteditem == 'true') {
                if(!isRestrictedModalShowRef.current){
                setIsRestrictedModalShow(true)
                var modalElement = document.getElementById(`productRestrictionModal0Mini`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();
                }
            } else {
                if (isCartEmptyCart == true) {
                    document.getElementById('productRestrictionModal0CloseMini') && document.getElementById('productRestrictionModal0CloseMini').click();
                   // window.location.reload()
                }
                else {
                    setHideModal(true);
                    if(checkoutQuarantineRef.current === '/checkout/login?qr=true'){
                        window.location.href = '/checkout/login?qr=true'
                    }else if(checkoutQuarantineRef.current === '/checkout/shipping?qr=true'){
                        console.log('checkoutQuarantine---if',checkoutQuarantineRef.current)
                        window.location.href = '/checkout/shipping?qr=true'
                    } else {
                        window.location.href = checkoutHref
                    }
                }

            }
        } 
    } else {
        await goToCheckout();
        window.location.href = checkoutHref
    }

    }
    async function goToCheckout() {
        var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/go-to-checkout`
        const inputMap = {
            "redirectCheckout": checkoutHref
        }
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
        if (res?.result === 'error') {
        //    setRestrictErrorMsg(res?.errorMessage)
        console.log('go-to-checkout returns error...');
        }
    }
    return (
        <>
            <li className={`text-center icon-width-popup popover__wrapper c-my-cart-image ${MyCartDetails?.additionalCss ? MyCartDetails.additionalCss :"" }`}>
                
                    {renderType === "TextOnly"? 
                         <a className='link-icon-style c-utility-nav-label' href="/checkout/cart">
                         <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{MyCartDetails?.displayName ? MyCartDetails.displayName : ""}</span>
                         <span className="c-utility-nav-cart-qty">
                             <div id="minicartCount">{miniCartItemsCount === '' ? "?" : miniCartItemsCount}</div>
                         </span>
                     </a>
                    : renderType === "IconOnly" ?
                    <a className='link-icon-style c-utility-nav-label' href="/checkout/cart">
                    {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                        <span className="c-utility-nav-cart-qty">
                                    
                        <div id="minicartCount">{miniCartItemsCount === '' ? "?" : miniCartItemsCount}</div>
                        </span>
                        </a>
                    : renderType === "LeftIconThenText" ? <a class="d-flex link-icon-style c-utility-nav-label d-flex" href="/checkout/cart">
                    {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{MyCartDetails?.displayName ? MyCartDetails.displayName : ""}</span>
                    <span className="c-utility-nav-cart-qty">
                                    
                        <div id="minicartCount">{miniCartItemsCount === '' ? "?" : miniCartItemsCount}</div>
                        </span>
                    </a>
                    : renderType === "LeftTextThenIcon" ? <a class="d-flex link-icon-style c-utility-nav-label" href="/checkout/cart">
                        <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{MyCartDetails?.displayName ? MyCartDetails.displayName : ""}</span>
                    {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                    <span className="c-utility-nav-cart-qty">
                        <div id="minicartCount">{miniCartItemsCount === '' ? "?" : miniCartItemsCount}</div>
                        </span>
                    </a>
                    : renderType === "TextAboveIcon" ? <a class="d-flex link-icon-style c-utility-nav-label" href="/checkout/cart">
                    {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{MyCartDetails?.displayName ? MyCartDetails.displayName : ""}</span>
                    <span className="c-utility-nav-cart-qty">
                                    
                        <div id="minicartCount">{miniCartItemsCount === '' ? "?" : miniCartItemsCount}</div>
                        </span>
                    </a>
                    : renderType === "TextBelowIcon" ? <a class="d-flex link-icon-style c-utility-nav-label" href="/checkout/cart">
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{MyCartDetails?.displayName ? MyCartDetails.displayName : ""}</span>
                {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                <span className="c-utility-nav-cart-qty">
                    <div id="minicartCount">{miniCartItemsCount === '' ? "?" : miniCartItemsCount}</div>
                    </span>
                </a>
                    : ""}
                
                
                
                
                {/* <a className='link-icon-style c-utility-nav-label' href="/checkout/cart">
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{MyCartDetails?.displayName ? MyCartDetails.displayName : ""}</span>
                    <span className="c-utility-nav-cart-qty">
                    <div id="minicartCount">{profileDetail && profileDetail.miniCartCount ? profileDetail.miniCartCount : 0}</div>
                        <div id="minicartCount">{miniCartItemsCount ? miniCartItemsCount : 0}</div>
                    </span>
                </a> */}
            {screenWidthRef.current > 991 ? 
                miniCartItemsCount != 0 ?
                    <div className="popover__content popover-mycart-content">
                        <div className='d-flex justify-content-between c-mini-cart-margin'>
                        {/* {renderType === "TextOnly"? 
                        <h6 className='contactfont-clr text-start'>{MyCartDetails?.displayName ? MyCartDetails.displayName :"" }</h6>
                        : renderType === "IconOnly" ? <>
                        {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt="" className='menu-img'/> :""}
                        </>
                        : renderType === "LeftIconThenText" ? <div class="d-flex">
                        {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt="" className='menu-img'/> :""}
                        <h6 className='contactfont-clr text-start'>{MyCartDetails?.displayName ? MyCartDetails.displayName :"" }</h6>
                        </div>
                        : renderType === "LeftTextThenIcon" ? <div class="d-flex">
                        <h6 className='contactfont-clr text-start'>{MyCartDetails?.displayName ? MyCartDetails.displayName :"" }</h6>
                        {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt="" className='menu-img'/> :""}
                        </div>
                        : renderType === "TextAboveIcon" ? <div class="">
                        {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt="" className='menu-img'/> :""}
                        <h6 className='contactfont-clr text-start mt-3'>{MyCartDetails?.displayName ? MyCartDetails.displayName :"" }</h6>
                        </div>
                        : renderType === "TextBelowIcon" ? <div><h6 className='contactfont-clr text-start mb-3'>{MyCartDetails?.displayName ? MyCartDetails.displayName :"" }</h6>
                        {MyCartDetails.menuIcon ? <i class={`${MyCartDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt="" className='menu-img'/> :""}
                        </div> 
                        : ""} */}
                        

                            <h6 className='contactfont-clr text-start'>My Cart</h6>
                            <div className='text-end'>
                                <Link to="/checkout/cart" style={{ textDecoration: "none" }}>
                                    <button className='mx-1 btn btn-sm btn-color'>Go to Cart</button>
                                </Link>
                                {profileDetail && profileDetail.userSegment &&
                                    (profileDetail.userSegment['Punchout Session'] === false ||
                                        profileDetail.userSegment['Punchout Session'] === 'false') &&
                                    profile && profile.userType == '3' ?
                                    <Link to={`${profile && profile.transient ? "/checkout/login" : "/checkout/int/save"}`} style={{ textDecoration: "none" }}>
                                        <button className='btn btn-sm btn-color'>Submit Quote Request</button>
                                    </Link>
                                    : profileDetail && profileDetail.userSegment &&
                                    (profileDetail.userSegment['Punchout Session'] === false ||
                                        profileDetail.userSegment['Punchout Session'] === 'false') &&
                                        profile && profile.userType == '2' ?
                                        <button onClick={handleCheckOut} className={`btn btn-sm btn-color  ${miniCartItems?.pricingMode === "contract" && miniCartItems?.promotionCode ? "btn-disable" : "btn-primary"}`}>Check Out</button> 
                                    :                              
                                    profileDetail && profileDetail.userSegment &&
                                        (profileDetail.userSegment['Punchout Session'] === false ||
                                            profileDetail.userSegment['Punchout Session'] === 'false') ?
                                            <button onClick={handleCheckOut} className='btn btn-sm btn-color'>Check Out</button>
                                        : ""
                                }


                            </div>
                            <div class="my-cart-arrow"></div>
                        </div>
                        {miniCartItems && miniCartItems.hazmatDetail && miniCartItems.hazmatDetail.warningMessage ?
                            <div className="alert alert-warning" role="alert">
                                <div className="d-flex align-items-center">
                                    <img fetchpriority="high" src="/vaststatic/deployed-assets/CbSite/prop65icon_lg.png" className="prop65-restrictions-icon" />
                                    <div className='text-start' dangerouslySetInnerHTML={{ __html: miniCartItems.hazmatDetail.warningMessage && miniCartItems.hazmatDetail.warningMessage }}></div>
                                </div>
                            </div>
                            : ""}
                        <ul className="list-unstyled cart-list">
                            {miniCartItems.cartItems && Object.entries(miniCartItems.cartItems).map(([key, cartItem]) => {
                                return (<>
                                    <li className="">
                                        <Link to={cartItem.url}>
                                            <div className="d-flex">
                                                <img fetchpriority="high" className="item-thumb" alt={cartItem.imgStr} onError={replaceImage} src={`${cartItem.imgStr}`} />
                                                <div className="row flex-fill">
                                                    <div className="col-12">
                                                        <span className="item-title" dangerouslySetInnerHTML={{ __html: cartItem.displayName }}>
                                                        </span>
                                                    </div>
                                                    <div className="col-6 mini-cart-item-label">
                                                        <span className="d-block fwb">Item #{cartItem.productId}</span>
                                                        <span className="d-block">Qty: {cartItem.quantity}</span>
                                                    </div>
                                                   { profileDetail && profileDetail.hidePrice && profileDetail.hidePrice === "false"?
                                                    <div className="col-6 mini-cart-item-value">
                                                        <span className="d-block item-price-total">
                                                            {cartItem.price}
                                                        </span>
                                                        {profile && profile.userType == '2' ? <>
                                                            {cartItem.retailPrice && cartItem.retailPrice ? <span class="mini-cart-retail-price">
                                                                Retail &nbsp;
                                                                <span class="retail-price">{cartItem.retailPrice}</span>
                                                            </span> : ""}
                                                        </> : ""}

                                                    </div>:""}
                                                </div>
                                            </div>
                                        </Link>
                                    </li> </>)
                            })}


                        </ul>
                        <dl className="mini-cart-total d-flex align-items-center justify-content-end">
                            <dt>Subtotal:</dt>
                            <dd>{profileDetail?.hidePrice === "false"? miniCartItems?.subTotal : ""}</dd>
                        </dl>
                        <div className='text-end mb-3'>

                            <Link to="/checkout/cart" style={{ textDecoration: "none" }}>
                                <button className='mx-1 btn btn-sm btn-color'>Go to Cart</button>
                            </Link>
                            {profileDetail && profileDetail.userSegment &&
                                (profileDetail.userSegment['Punchout Session'] === false ||
                                    profileDetail.userSegment['Punchout Session'] === 'false') &&
                                profile && profile.userType == '3' ?
                                <Link to={`${profile && profile.transient ? "/checkout/login" : "/checkout/int/save"}`} style={{ textDecoration: "none" }}>
                                    <button className='btn btn-sm btn-color'>Submit Quote Request</button>
                                </Link>
                                : profileDetail && profileDetail.userSegment &&
                                (profileDetail.userSegment['Punchout Session'] === false ||
                                    profileDetail.userSegment['Punchout Session'] === 'false') &&
                                    profile && profile.userType == '2' ?
                                    <button onClick={handleCheckOut} className={`btn btn-sm btn-color  ${miniCartItems?.pricingMode === "contract" && miniCartItems?.promotionCode ? "btn-disable" : "btn-primary"}`}>Check Out</button> 

                                :profileDetail && profileDetail.userSegment &&
                                    (profileDetail.userSegment['Punchout Session'] === false ||
                                        profileDetail.userSegment['Punchout Session'] === 'false') ?
                                        <button onClick={handleCheckOut} className={`btn btn-sm btn-color`}>Check Out</button> : ""
                            }
                        </div>
                    </div>
                    :
                    <div className="popover__content popover-mycart-content">
                        <h6 className='contactfont-clr text-start'>My Cart</h6>
                        <p className="popover__message text-start">Your Shopping Cart is currently empty. Use <strong>Quick Order</strong> or <strong>Search</strong> to quickly add items to your order! </p>
                        <div class="my-cart-arrow"></div>
                    </div>
                :""}
            </li>

            {/* modal */}
            <ProductRestrictModalMiniCart
                restrictedTitle={restrictedTitle}
                restrictedDiscontinueItem={restrictedDiscontinueItem}
                restrictedItemGeo={restrictedItemGeo}
                restrictedItem={restrictedItem}
                restrictedItemSpecialUser={restrictedItemSpecialUser}
                handleGetCartList={handleGetCartList}
                handleCheckOut={handleCheckOut}
                hasScrollView={hasScrollView}
                setHasScrollView={setHasScrollView}
                setCheckoutQuarantine={setCheckoutQuarantine}
                cartCount={profileDetail?.miniCartCount}
                setIsRestrictedModalShow = {setIsRestrictedModalShow}
                hideModal={hideModalRef.current}
                guestUser={profileDetail?.transient}
            />
        </>
    )
}

export default MyCartTile
